<template>
  <monitor-video
    :icon-color="online ? 'success' : 'danger'"
    :show-url="false"
    :progress="false"
    :show-player-info="false"
    fill-height
    :edit="true"
    edit-text="Edit instance"
    :color-key="color_key"
    @close="close"
    @edit="open_editor"
  >
    <template #title>
      {{title}}
    </template>
    <template #subtitle>
      {{subtitle}}
    </template>
    <template #content>
      <instance-stats :id="data.instance.id" :small="true" :show_title_and_channel="true"></instance-stats>
    </template>
  </monitor-video>
</template>

<script>
import ChannelModel from '@/models/channel.js';
import InstanceModel from '@/models/instance.js';
import { monitor2ColorKey, toggleMonitor2Items } from '@/models/monitor.js';
import MonitorVideo from '@/components/MonitorVideo.vue';
import InstanceStats from '@/components/instances/Stats.vue';

export default {
  // data: {id, type: "instance", instance}
  props: ['data'],
  components: {
    MonitorVideo,
    InstanceStats
  },
  computed: {
    color_key () {
      return monitor2ColorKey(this.data.id);
    },
    online () {
      return InstanceModel.is_online(this.data.instance);
    },
    title () {
      return InstanceModel.title(this.data.instance);
    },
    // Channel of the instance, or its type for servers
    subtitle () {
      var channel = InstanceModel.channel(this.data.instance);
      return channel ? ChannelModel.title(channel) : (this.data.instance.type || "");
    }
  },
  methods: {
    open_editor () {
      this.$router.push("/monitor2/instance/" + this.data.instance.id);
    },
    close () {
      if (!this.$store.state.account) return;
      var acc = _.cloneDeep(this.$store.state.account);
      this.$store.dispatch("update_profile_optimistic", toggleMonitor2Items(acc, [this.data.id], false));
    }
  }
}
</script>
